import React from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';

import { Icon } from './Icon';

export interface IAdornmentProps {
  type: string;
  error: boolean;
}

export const EndAdornment = (props: IAdornmentProps) => (
  <InputAdornment position="end" className="input-icon override">
    <Icon {...props} />
  </InputAdornment>
);
